/**
 * Master Muscles — Cart Sheet & global add-to-cart
 * Mobile: bottom sheet | Desktop: right drawer
 */
(function () {
  'use strict';

  var CFG = window.MM_CART_SHEET_CONFIG || {};
  var root = null;
  var isOpen = false;
  var lastAddedTitle = '';
  var skipGlobalHook = false;
  var cartCache = null;
  var pendingKeys = {};
  var lastUserLineOpAt = 0;
  var qtyTimers = {};
  var qtySafetyTimers = {};
  var lastRecsKey = '';
  var sddTimer = null;
  var actionsBound = false;
  var cartUpdateToken = 0;
  var cartFetchChain = Promise.resolve();
  var cartFetchSeq = 0;
  var cartMutChain = Promise.resolve();
  var pendingAddChain = Promise.resolve();
  var sheetUpdatingCount = 0;
  var productVariantsCache = {};
  var variantCompareCache = {};
  var dynamicShippingKey = '';

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    if (typeof window.mmFormatMoneyHtml === 'function') {
      return window.mmFormatMoneyHtml(cents);
    }
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return (cents / 1000).toFixed(3);
  }

  function localePrefix() {
    var p = window.location.pathname;
    var m = p.match(/^(\/[a-z]{2}(-[a-z]{2})?)\//i);
    return m ? m[1] : '';
  }

  function apiRoot() {
    if (window.MMRecommendations && typeof window.MMRecommendations.apiRoot === 'function') {
      return window.MMRecommendations.apiRoot();
    }
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var r = window.Shopify.routes.root;
      if (r.slice(-1) !== '/') r += '/';
      return r;
    }
    var prefix = localePrefix();
    return prefix ? prefix + '/' : '/';
  }

  function marketCountry() {
    var host = document.body || document.documentElement;
    var html = document.documentElement;
    var country = '';
    if (host && host.getAttribute) country = host.getAttribute('data-mm-country') || '';
    if (!country && html && html.getAttribute) country = html.getAttribute('data-mm-country') || '';
    if (!country) country = CFG.countryCode || '';

    var currency = '';
    if (html && html.getAttribute) currency = html.getAttribute('data-mm-currency') || '';
    try {
      currency = currency || localStorage.getItem('mm_display_currency_user') || '';
    } catch (e) {}
    if (String(currency).toUpperCase() === 'SAR') return 'SA';

    country = String(country || '').trim().toUpperCase();
    if (country) return country;

    return 'BH';
  }

  function isSaudiMarket() {
    return marketCountry() === 'SA';
  }

  function countryInList(raw, fallback) {
    var country = marketCountry();
    var list;
    if (raw !== undefined && raw !== null) {
      list = String(raw).trim();
      if (!list) return false;
    } else {
      list = String(fallback || '').trim();
      if (!list) return false;
    }
    if (list === '*') return true;
    return list.split(',').map(function (v) { return String(v || '').trim().toUpperCase(); }).some(function (code) {
      return code === '*' || code === country;
    });
  }

  function featureVisible(key, fallback) {
    return countryInList(CFG[key], fallback);
  }

  function hideTierGiftUi() {
    $$('[data-mm-tier-ladder]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function productPageUrl(product) {
    if (window.MMRecommendations && typeof window.MMRecommendations.productUrl === 'function') {
      return window.MMRecommendations.productUrl(product);
    }
    var handle = product && product.handle;
    if (!handle) return '#';
    return apiRoot() + 'products/' + handle;
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function cssAttrEscape(s) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(String(s));
    }
    return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getItemRow(key) {
    if (!root || !key) return null;
    return root.querySelector('.mm-cart-sheet__item[data-cart-key="' + cssAttrEscape(key) + '"]');
  }

  function clearItemBusy(key) {
    delete pendingKeys[key];
    clearTimeout(qtyTimers[key]);
    clearTimeout(qtySafetyTimers[key]);
    delete qtyTimers[key];
    delete qtySafetyTimers[key];
    var row = getItemRow(key);
    if (row) {
      row.classList.remove('mm-cart-sheet__item--updating', 'mm-cart-sheet__item--removing');
      var qty = row.querySelector('.mm-cart-sheet__qty');
      if (qty) qty.classList.remove('mm-cart-sheet__qty--busy');
      var picker = getVariantPicker(row);
      if (picker) picker.classList.remove('is-busy');
    }
  }

  function isCartPayload(data) {
    return data && Array.isArray(data.items) && typeof data.item_count === 'number';
  }

  function getCartIconEl() {
    return (
      document.querySelector('[data-mm-cart-trigger] .mm-action-icon') ||
      document.querySelector('.mm-action-link[href*="/cart"] .mm-action-icon') ||
      document.querySelector('.mm-cart-badge')?.closest('.mm-action-icon')
    );
  }

  function updateBadges(count, animate) {
    var n = parseInt(count, 10) || 0;
    document
      .querySelectorAll('.cart-count, [data-cart-count], .mm-cart-count, .mm-cart-badge, .mm-bottom-nav-badge')
      .forEach(function (el) {
        el.textContent = n;
        if (el.classList.contains('mm-cart-badge') || el.classList.contains('mm-bottom-nav-badge')) {
          el.style.display = n > 0 ? 'flex' : 'none';
        }
        if (animate) {
          el.classList.remove('mm-cart-badge--bounce');
          void el.offsetWidth;
          el.classList.add('mm-cart-badge--bounce');
        }
      });

    var titleCount = $('#mmCartSheetCount');
    if (titleCount) titleCount.textContent = n;

    if (animate) {
      var iconWrap = document.querySelector('[data-mm-cart-trigger]');
      if (iconWrap) {
        iconWrap.classList.remove('mm-cart-icon--pulse');
        void iconWrap.offsetWidth;
        iconWrap.classList.add('mm-cart-icon--pulse');
        setTimeout(function () {
          iconWrap.classList.remove('mm-cart-icon--pulse');
        }, 600);
      }
    }
  }

  function flyToCart(sourceEl, imageUrl) {
    if (!imageUrl || !sourceEl) return;
    var target = getCartIconEl();
    if (!target) return;

    var srcRect = sourceEl.getBoundingClientRect();
    var tgtRect = target.getBoundingClientRect();
    var fly = document.createElement('img');
    fly.className = 'mm-cart-fly';
    fly.src = imageUrl;
    fly.alt = '';
    fly.style.left = srcRect.left + srcRect.width / 2 - 22 + 'px';
    fly.style.top = srcRect.top + srcRect.height / 2 - 22 + 'px';
    fly.style.transition =
      'left 0.38s cubic-bezier(0.22, 1, 0.36, 1), top 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease, transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
    document.body.appendChild(fly);

    requestAnimationFrame(function () {
      fly.style.left = tgtRect.left + tgtRect.width / 2 - 10 + 'px';
      fly.style.top = tgtRect.top + tgtRect.height / 2 - 10 + 'px';
      fly.style.opacity = '0.25';
      fly.style.transform = 'scale(0.3)';
    });

    setTimeout(function () {
      fly.remove();
    }, 400);
  }

  function cartApi(path) {
    return apiRoot() + String(path || '').replace(/^\//, '');
  }

  function cartPause(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms || 400);
    });
  }

  function fetchCartJson(path, opts, attempt) {
    attempt = attempt || 0;
    opts = opts || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(cartApi(path), Object.assign({ credentials: 'same-origin' }, opts, { headers: headers }))
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          if (text) {
            try { data = JSON.parse(text); } catch (e) { data = null; }
          }
          if (data && typeof data === 'object') {
            if (!r.ok) {
              if ((r.status === 429 || r.status === 503) && attempt < 3) {
                return cartPause(1000 * Math.pow(2, attempt)).then(function () {
                  return fetchCartJson(path, opts, attempt + 1);
                });
              }
              throw data;
            }
            return data;
          }
          if ((r.status === 429 || r.status === 503) && attempt < 3) {
            return cartPause(1000 * Math.pow(2, attempt)).then(function () {
              return fetchCartJson(path, opts, attempt + 1);
            });
          }
          var err = new Error('Cart API returned non-JSON');
          err.status = r.status;
          throw err;
        });
      });
  }

  function fetchCart() {
    var seq = ++cartFetchSeq;
    var next = cartFetchChain.then(function () {
      return fetchCartJson('cart.js');
    });
    cartFetchChain = next.catch(function () {});
    return next.then(function (cart) {
      if (seq !== cartFetchSeq) return cartCache || cart;
      return cart;
    });
  }

  function productHandleFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function withTax(cents) {
    if (CFG.taxEnabled && CFG.taxRate) {
      return Math.round(cents * CFG.taxRate);
    }
    return cents;
  }

  function getMoneyDivisor() {
    var d = parseInt(CFG.moneyDivisor, 10);
    if (d === 100 || d === 1000) return d;
    var attr = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (attr === 100 || attr === 1000) return attr;
    return 1000;
  }

  /** Plain text — amount already includes tax (no HTML, no double tax). */
  function formatMoneyTaxed(taxedMinor) {
    var div = getMoneyDivisor();
    if (typeof window.mmFormatMoneyTaxed === 'function') {
      return window.mmFormatMoneyTaxed(taxedMinor, div);
    }
    var dec = div === 1000 ? 3 : 2;
    return (taxedMinor / div).toFixed(dec) + ' BHD';
  }

  function getShippingEligibleTotal(cart) {
    if (window.mmShippingEligibility && typeof window.mmShippingEligibility.calculateEligibleTotalSync === 'function') {
      return window.mmShippingEligibility.calculateEligibleTotalSync(cart).eligible;
    }
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function replaceAmount(str, taxedRemainingMinor) {
    if (!str) return '';
    var formatted = formatMoneyTaxed(taxedRemainingMinor);
    return str.replace(/\[amount\]/g, formatted).replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function shippingRatesQuery() {
    var country = (CFG.dynamicShippingCountry || 'SA').toUpperCase();
    var params = new URLSearchParams();
    params.set('shipping_address[country_code]', country);
    params.set('shipping_address[country]', country === 'SA' ? 'Saudi Arabia' : country);
    return params.toString();
  }

  function formatShippingRate(rate) {
    if (typeof window.mmFormatShippingRate === 'function') {
      return window.mmFormatShippingRate(rate, {
        country: CFG.dynamicShippingCountry || marketCountry(),
        displayCurrency: marketCountry() === 'SA' ? 'SAR' : undefined,
      });
    }
    if (!rate) return '';
    var price = rate.price || rate.price_min || rate.presentment_price;
    if (price == null || price === '') return '';
    return String(price);
  }

  function pollShippingRates(query, attempts) {
    return cartPause(650).then(function () {
      return fetch(cartApi('cart/async_shipping_rates.json?' + query), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
    }).then(function (r) {
      if (!r || !r.ok) return null;
      return r.json();
    }).then(function (data) {
      var rates = data && (data.shipping_rates || data.rates);
      if (!Array.isArray(rates) || !rates.length) return null;
      return rates[0];
    }).catch(function () {
      return null;
    }).then(function (rate) {
      if (rate || attempts <= 1) return rate;
      return pollShippingRates(query, attempts - 1);
    });
  }

  function readShippingRates() {
    var query = shippingRatesQuery();
    return fetch(cartApi('cart/prepare_shipping_rates.json?' + query), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).catch(function () {
      return null;
    }).then(function () {
      return pollShippingRates(query, 4);
    });
  }

  function renderDynamicShipping(cart) {
    var wrap = $('#mmCartSheetDynamicShipping');
    var text = $('#mmCartSheetDynamicShippingText');
    if (!wrap || !text) return;
    var targetCountry = String(CFG.dynamicShippingCountry || 'SA').toUpperCase();
    if (!CFG.dynamicShippingEnabled || marketCountry() !== targetCountry || !cart.items || !cart.items.length) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var key = [
      cart.item_count || 0,
      cart.total_price || 0,
      cart.total_weight || 0,
      (cart.items || []).map(function (item) {
        return [item.variant_id, item.quantity].join(':');
      }).join(',')
    ].join('|');

    if (key === dynamicShippingKey && wrap.getAttribute('data-rate-ready') === '1') return;
    dynamicShippingKey = key;
    wrap.removeAttribute('data-rate-ready');
    text.textContent = CFG.dynamicShippingLoading || 'Calculating shipping by cart weight...';

    readShippingRates().then(function (rate) {
      var rateText = formatShippingRate(rate);
      wrap.setAttribute('data-rate-ready', '1');
      if (rateText) {
        text.textContent = (CFG.dynamicShippingEstimated || 'Current shipping rate:') + ' ' + rateText;
      } else {
        text.textContent = CFG.dynamicShippingFallback || 'Shipping changes by weight and appears at checkout.';
      }
    });
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function getStoreNow() {
    var tz = CFG.timezone || 'Asia/Bahrain';
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
    } catch (e) {
      return new Date();
    }
  }

  function updateSdd() {
    var wrap = $('#mmCartSheetSdd');
    var textEl = $('#mmCartSheetSddText');
    var timerEl = $('#mmCartSheetSddTimer');
    var saWrap = $('#mmCartSheetSaDelivery');
    var saText = $('#mmCartSheetSaDeliveryText');

    var showStaticDelivery = featureVisible('staticDeliveryCountries');
    var showSdd = featureVisible('sddCountries');

    if (!showStaticDelivery && !showSdd) {
      if (wrap) wrap.remove();
      if (saWrap) saWrap.remove();
      return;
    }

    if (showStaticDelivery) {
      if (wrap) wrap.hidden = true;
      if (timerEl) timerEl.hidden = true;
      if (saWrap) {
        saWrap.hidden = false;
        if (saText) saText.textContent = CFG.saDeliveryText || '';
      }
      return;
    }

    if (saWrap) saWrap.hidden = true;

    if (!showSdd) {
      if (wrap) wrap.hidden = true;
      if (timerEl) timerEl.hidden = true;
      return;
    }

    if (!textEl || !wrap) return;

    if (wrap) wrap.hidden = false;

    var cutoffHour = CFG.sddHour || 20;
    var now = getStoreNow();
    var cutoff = new Date(now.getTime());
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (now >= cutoff) {
      if (timerEl) timerEl.hidden = true;
      textEl.textContent = CFG.sddTomorrow || CFG.sddTitle || 'Order before 8 PM for same-day delivery';
      if (wrap) wrap.classList.add('mm-cart-sheet__sdd--closed');
      return;
    }

    if (wrap) wrap.classList.remove('mm-cart-sheet__sdd--closed');
    var diff = cutoff.getTime() - now.getTime();
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    var hEl = $('#mmCartSheetSddH');
    var mEl = $('#mmCartSheetSddM');
    var sEl = $('#mmCartSheetSddS');
    if (timerEl && hEl && mEl && sEl) {
      timerEl.hidden = false;
      hEl.textContent = pad2(h);
      mEl.textContent = pad2(m);
      sEl.textContent = pad2(s);
    }

    textEl.textContent = CFG.sddTitle || 'Order before 8 PM for same-day delivery';
  }

  function cacheVariantComparePrices(product) {
    if (!product || !product.variants) return;
    product.variants.forEach(function (v) {
      var price = parseInt(v.price, 10) || 0;
      var compareAt = parseInt(v.compare_at_price, 10) || 0;
      if (compareAt > price) variantCompareCache[v.id] = compareAt;
    });
  }

  function getCompareAtUnit(item, row) {
    var fromCart = parseInt(item.compare_at_price, 10) || 0;
    if (fromCart > 0) return fromCart;

    var vid = item.variant_id;
    if (vid && variantCompareCache[vid]) return variantCompareCache[vid];

    if (row) {
      var fromRow = parseInt(row.getAttribute('data-compare-at-unit'), 10) || 0;
      if (fromRow > 0) return fromRow;
    }

    return 0;
  }

  function lineDiscountTotal(item) {
    var sum = 0;
    (item.line_level_discount_allocations || []).forEach(function (alloc) {
      sum += alloc.amount || 0;
    });
    return sum;
  }

  function lineIsFullyDiscounted(item) {
    var qty = item.quantity || 1;
    var finalLine = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * qty;
    if (finalLine <= 0) return true;
    var originalLine = item.original_line_price != null
      ? item.original_line_price
      : (item.price || 0) * qty;
    if (originalLine > 0 && lineDiscountTotal(item) >= originalLine) return true;
    return false;
  }

  function isTierGiftLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._gift === 'true';
  }

  function normVariantId(id) {
    return String(id || '').split('/').pop();
  }

  function parseFlashDeals(cart) {
    if (!cart || !cart.attributes) return [];
    var raw = cart.attributes._flash_deals_data;
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function getFlashDealForItem(item, cart) {
    if (!item) return null;
    var vid = normVariantId(item.variant_id);
    var deals = parseFlashDeals(cart || cartCache);
    var best = null;
    for (var i = 0; i < deals.length; i++) {
      var d = deals[i];
      if (!d || !d.variantId) continue;
      if (normVariantId(d.variantId) !== vid) continue;
      if (d.type !== 'wheel' && d.type !== 'flash') continue;
      var pct = parseFloat(d.discountPercent) || 0;
      if (!best || pct > (parseFloat(best.discountPercent) || 0)) best = d;
    }
    return best;
  }

  function computeFlashDealPricing(item, deal) {
    if (!item || !deal) return null;
    var qty = item.quantity || 1;
    var unit = item.original_price != null ? item.original_price : (item.price || 0);
    var originalLine = item.original_line_price != null ? item.original_line_price : unit * qty;
    var pct = Math.min(100, Math.max(0, parseFloat(deal.discountPercent) || 0));
    var dealQty = Math.max(1, parseInt(deal.quantity, 10) || 1);
    var discountedUnits = Math.min(qty, dealQty);
    var fullUnits = Math.max(0, qty - discountedUnits);
    var saleLine = Math.round(fullUnits * unit + discountedUnits * unit * (1 - pct / 100));
    if (deal.isFreeGift && pct >= 100) {
      saleLine = Math.round(fullUnits * unit);
    }
    if (saleLine >= originalLine) return null;
    var message = deal.type === 'wheel'
      ? (pct >= 100 || deal.isFreeGift ? 'Wheel Gift' : 'Wheel Prize')
      : 'Flash Deal';
    return {
      hasSale: true,
      saleLine: saleLine,
      compareLine: originalLine,
      compareAtUnit: unit,
      saved: originalLine - saleLine,
      isFlashDeal: true,
      dealMessage: message,
    };
  }

  function getItemPricing(item, row) {
    var qty = item.quantity || 1;
    var props = item.properties || {};
    var finalLine = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * qty;
    var originalLine = item.original_line_price != null
      ? item.original_line_price
      : (item.price || 0) * qty;

    if (isTierGiftLine(item)) {
      var confirmed = lineIsFullyDiscounted(item);
      return {
        hasSale: confirmed,
        saleLine: confirmed ? 0 : finalLine,
        compareLine: originalLine,
        compareAtUnit: qty > 0 ? Math.round(originalLine / qty) : 0,
        saved: confirmed ? originalLine : Math.max(0, originalLine - finalLine),
        isGift: true,
        giftConfirmed: confirmed
      };
    }
    var finalLine = item.final_line_price || 0;
    var unitFinal = item.final_price || Math.round(finalLine / qty) || 0;
    var compareAtUnit = getCompareAtUnit(item, row);

    if (compareAtUnit > unitFinal) {
      var compareLine = compareAtUnit * qty;
      if (compareLine > finalLine) {
        return {
          hasSale: true,
          saleLine: finalLine,
          compareLine: compareLine,
          compareAtUnit: compareAtUnit,
          saved: compareLine - finalLine,
        };
      }
    }

    if (item.original_line_price > finalLine) {
      return {
        hasSale: true,
        saleLine: finalLine,
        compareLine: item.original_line_price,
        compareAtUnit: Math.round(item.original_line_price / qty),
        saved: item.original_line_price - finalLine,
      };
    }

    var flashDeal = getFlashDealForItem(item, cartCache);
    if (flashDeal) {
      var projected = computeFlashDealPricing(item, flashDeal);
      if (projected) return projected;
    }

    return { hasSale: false, saleLine: finalLine, compareAtUnit: 0 };
  }

  function refreshItemPriceRow(item) {
    if (!item || !item.key) return;
    var row = getItemRow(item.key);
    if (!row) return;
    var prices = row.querySelector('.mm-cart-sheet__item-prices');
    if (!prices) return;
    var pricing = getItemPricing(item, row);
    prices.outerHTML = buildItemPriceHtml(item, row);
    if (pricing.hasSale && pricing.compareAtUnit) {
      row.setAttribute('data-compare-at-unit', pricing.compareAtUnit);
    }
  }

  function enrichCartItemPrices(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();

    var jobs = cart.items.map(function (item) {
      var row = getItemRow(item.key);
      if (getItemPricing(item, row).hasSale) return Promise.resolve();

      var handle = item.handle || (row && row.getAttribute('data-product-handle'));
      if (!handle) return Promise.resolve();

      return fetchProductVariants(handle).then(function (product) {
        if (!product) return;
        cacheVariantComparePrices(product);
        refreshItemPriceRow(item);
      });
    });

    return Promise.all(jobs);
  }

  function buildItemPriceHtml(item, row) {
    var pricing = getItemPricing(item, row);
    var html = '<div class="mm-cart-sheet__item-prices">';

    if (pricing.isGift) {
      if (pricing.giftConfirmed) {
        html +=
          '<span class="mm-cart-sheet__price-sale">' +
          escapeHtml((document.documentElement.lang || '').indexOf('ar') === 0 ? 'مجاني' : 'FREE') +
          '</span>';
        if (pricing.compareLine > 0) {
          html += '<span class="mm-cart-sheet__price-compare">' + formatMoney(pricing.compareLine) + '</span>';
        }
      } else {
        html += '<span class="mm-cart-sheet__price-current">' + formatMoney(pricing.saleLine) + '</span>';
        if (pricing.compareLine > pricing.saleLine) {
          html += '<span class="mm-cart-sheet__price-compare">' + formatMoney(pricing.compareLine) + '</span>';
        }
      }
    } else if (pricing.hasSale) {
      html +=
        '<div class="mm-cart-sheet__price-row">' +
        '<span class="mm-cart-sheet__price-label">' +
        escapeHtml(CFG.priceAfter || 'After') +
        '</span>' +
        '<span class="mm-cart-sheet__price-sale">' +
        formatMoney(pricing.saleLine) +
        '</span></div>' +
        '<div class="mm-cart-sheet__price-row">' +
        '<span class="mm-cart-sheet__price-label">' +
        escapeHtml(CFG.priceBefore || 'Before') +
        '</span>' +
        '<span class="mm-cart-sheet__price-compare">' +
        formatMoney(pricing.compareLine) +
        '</span></div>' +
        '<span class="mm-cart-sheet__price-saved">' +
        escapeHtml(CFG.youSave || 'You save') +
        ' ' +
        formatMoney(pricing.saved) +
        '</span>';
    } else {
      html += '<span class="mm-cart-sheet__price-current">' + formatMoney(pricing.saleLine) + '</span>';
    }

    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      item.line_level_discount_allocations.forEach(function (alloc) {
        var app = alloc.discount_application || {};
        var title = app.title || 'Discount';
        if (pricing.isGift && !/cart gift|gift reward/i.test(title)) return;
        html +=
          '<span class="mm-cart-sheet__discount-pill">🏷️ ' +
          escapeHtml(title) +
          '</span>';
      });
    } else if (pricing.isFlashDeal && pricing.dealMessage) {
      html +=
        '<span class="mm-cart-sheet__discount-pill">🏷️ ' +
        escapeHtml(pricing.dealMessage) +
        '</span>';
    }

    html += '</div>';
    return html;
  }

  function renderIncentives(cart) {
    var wrap = $('#mmCartSheetIncentives');
    if (!wrap) return;

    if (!cart.items || !cart.items.length) {
      wrap.hidden = true;
      renderDynamicShipping(cart);
      return;
    }
    wrap.hidden = false;
    renderDynamicShipping(cart);

    var showShipping = featureVisible('freeShippingCountries');
    var showGift = featureVisible('giftCountries');
    var shipVisible = $('#mmCartSheetShip');
    var shipNoticeVisible = $('#mmCartSheetShipNotice');
    if (shipVisible) shipVisible.hidden = !showShipping;
    if (shipNoticeVisible && !showShipping) shipNoticeVisible.hidden = true;
    var appTierGiftsActive = window.MMCartTierGifts && typeof window.MMCartTierGifts.isActive === 'function' && window.MMCartTierGifts.isActive();

    var progressOpts = {
      threshold: CFG.freeShippingThreshold || (window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.threshold) || 2000,
      taxEnabled: CFG.taxEnabled != null ? CFG.taxEnabled : !!(window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.taxEnabled),
      taxRate: CFG.taxRate || (window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.taxRate) || 1
    };

    function applyIncentives(shipProgress) {
      var shipEl = $('#mmCartSheetShip');
      var shipMsg = $('#mmCartSheetShipMsg');
      var shipFill = $('#mmCartSheetShipFill');
      var shipNotice = $('#mmCartSheetShipNotice');
      if (shipEl && shipMsg && shipFill && showShipping) {
        var wasUnlocked = shipEl.classList.contains('is-unlocked');
        if (shipProgress.unlocked) {
          shipEl.classList.add('is-unlocked');
          shipMsg.textContent = CFG.shippingUnlocked || '🎉 Free shipping unlocked!';
          if (!wasUnlocked) shipEl.classList.add('mm-cart-sheet__incentive--celebrate');
        } else {
          shipEl.classList.remove('is-unlocked', 'mm-cart-sheet__incentive--celebrate');
          shipMsg.textContent = replaceAmount(
            CFG.shippingRemaining || 'Add [amount] more for FREE shipping!',
            shipProgress.remaining
          );
        }
        shipFill.style.width = shipProgress.progress + '%';
      }
      if (shipNotice && showShipping) {
        shipNotice.hidden = !shipProgress.hasExcluded;
        if (shipProgress.hasExcluded) {
          shipNotice.textContent =
            '⚠️ ' +
            (CFG.shippingExclusionNotice ||
              'Some items do not count toward free shipping (+20 BD applies)');
        }
      }

      var giftEl = $('#mmCartSheetGift');
      var giftMsg = $('#mmCartSheetGiftMsg');
      var giftFill = $('#mmCartSheetGiftFill');
      if (giftEl) giftEl.hidden = !showGift;
      if (!showGift) hideTierGiftUi();
      if (appTierGiftsActive || !showGift) {
        updateSdd();
        return;
      }
      if (giftEl && giftMsg && giftFill) {
        var div = getMoneyDivisor();
        var giftGoalBhd = parseFloat(CFG.giftGoalBhd) || 50;
        var giftThresholdBase = CFG.giftThreshold || giftGoalBhd * div;
        if (div === 100 && giftThresholdBase >= giftGoalBhd * 1000) {
          giftThresholdBase = giftGoalBhd * div;
        }
        if (giftThresholdBase > 0) {
          var giftCompareThreshold = giftThresholdBase;
          var giftTotalCompare = cart.total_price || 0;
          var giftRemaining = Math.max(0, giftCompareThreshold - giftTotalCompare);
          var giftProgress =
            giftCompareThreshold > 0
              ? Math.min(100, Math.round((giftTotalCompare * 100) / giftCompareThreshold))
              : 0;
          var giftWas = giftEl.classList.contains('is-unlocked');
          if (giftRemaining <= 0) {
            giftEl.classList.add('is-unlocked');
            giftMsg.textContent = CFG.giftUnlocked || '🎁 FREE gift unlocked!';
            if (!giftWas) giftEl.classList.add('mm-cart-sheet__incentive--celebrate');
          } else {
            giftEl.classList.remove('is-unlocked', 'mm-cart-sheet__incentive--celebrate');
            giftMsg.textContent = replaceAmount(
              CFG.giftRemaining || 'Add [amount] more for a FREE gift!',
              giftRemaining
            );
          }
          giftFill.style.width = giftProgress + '%';
        }
      }

      updateSdd();
    }

    function buildLocalShippingProgress() {
      if (
        window.mmShippingEligibility &&
        typeof window.mmShippingEligibility.calculateEligibleTotalSync === 'function' &&
        typeof window.mmShippingEligibility.buildProgressFromEligible === 'function'
      ) {
        var syncResult = window.mmShippingEligibility.calculateEligibleTotalSync(cart);
        return window.mmShippingEligibility.buildProgressFromEligible(
          syncResult.eligible,
          syncResult.hasExcluded,
          progressOpts
        );
      }
      var threshold = parseInt(progressOpts.threshold, 10) || 0;
      var taxEnabled = !!progressOpts.taxEnabled;
      var taxRate = parseFloat(progressOpts.taxRate) || 1;
      var eligiblePreTax = getShippingEligibleTotal(cart);
      var eligibleCompare = taxEnabled ? Math.round(eligiblePreTax * taxRate) : eligiblePreTax;
      var remaining = Math.max(0, threshold - eligibleCompare);
      return {
        remaining: remaining,
        progress: threshold > 0 ? Math.min(100, Math.round((eligibleCompare * 100) / threshold)) : 0,
        unlocked: remaining <= 0,
        hasExcluded: false
      };
    }

    function runProgress() {
      applyIncentives(buildLocalShippingProgress());
      if (window.mmShippingEligibility && typeof window.mmShippingEligibility.refreshFromCart === 'function') {
        window.mmShippingEligibility.refreshFromCart(cart, progressOpts).then(function (shipProgress) {
          if (shipProgress) applyIncentives(shipProgress);
        }).catch(function () {});
      }
    }

    runProgress();
  }

  function renderDiscounts(cart) {
    var discountWrap = $('#mmCartSheetDiscount');
    if (discountWrap) discountWrap.hidden = !featureVisible('discountCountries');
    if (!featureVisible('discountCountries')) return;
    var appliedWrap = $('#mmCartSheetDiscountApplied');
    if (!appliedWrap) return;

    var codes = [];
    if (cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach(function (d) {
        if (d.type === 'discount_code') codes.push(d);
      });
    }

    if (!codes.length) {
      appliedWrap.hidden = true;
      appliedWrap.innerHTML = '';
      return;
    }

    appliedWrap.hidden = false;
    var html = '';
    codes.forEach(function (d) {
      html +=
        '<div class="mm-cart-sheet__discount-tag">' +
        '<span>🏷️ ' +
        escapeHtml(d.title) +
        '</span>' +
        '<button type="button" data-mm-remove-discount="' +
        escapeHtml(d.title) +
        '" aria-label="Remove">×</button></div>';
    });
    appliedWrap.innerHTML = html;
  }

  function showDiscountMsg(text, type) {
    var el = $('#mmCartSheetDiscountMsg');
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    el.className = 'mm-cart-sheet__discount-msg mm-cart-sheet__discount-msg--' + (type || 'info');
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.hidden = true;
    }, 4000);
  }

  function applyDiscount() {
    if (!featureVisible('discountCountries')) return;
    var input = $('#mmCartSheetDiscountInput');
    var btn = $('#mmCartSheetDiscountBtn');
    if (!input || !btn) return;

    var code = input.value.trim();
    if (!code) {
      input.classList.add('mm-cart-sheet__discount-input--error');
      showDiscountMsg(CFG.discountEmpty || 'Enter a discount code', 'error');
      return;
    }
    input.classList.remove('mm-cart-sheet__discount-input--error');
    btn.classList.add('is-loading');
    btn.disabled = true;
    input.disabled = true;
    setSheetUpdating(true, CFG.updating || 'Updating cart…');

    fetchCartJson('cart.js')
      .then(function (cart) {
        var existing = [];
        if (cart.cart_level_discount_applications) {
          cart.cart_level_discount_applications.forEach(function (d) {
            if (d.type === 'discount_code') existing.push(d.title);
          });
        }
        existing.push(code);
        return fetchCartJson('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: existing.join(',') }),
        });
      })
      .then(function (data) {
        var ok = false;
        if (data.discount_codes) {
          data.discount_codes.forEach(function (d) {
            if (d.code.toLowerCase() === code.toLowerCase() && d.applicable !== false) ok = true;
          });
        }
        if (ok) {
          input.value = '';
          showDiscountMsg(CFG.discountSuccess || 'Discount applied!', 'success');
          applyCartUpdate(data);
        } else {
          showDiscountMsg(CFG.discountInvalid || 'Invalid discount code', 'error');
        }
      })
      .catch(function () {
        showDiscountMsg(CFG.discountInvalid || 'Invalid discount code', 'error');
      })
      .finally(function () {
        setSheetUpdating(false);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        input.disabled = false;
      });
  }

  function removeDiscount(code) {
    fetchCartJson('cart.js')
      .then(function (cart) {
        var remaining = [];
        if (cart.cart_level_discount_applications) {
          cart.cart_level_discount_applications.forEach(function (d) {
            if (d.type === 'discount_code' && d.title !== code) remaining.push(d.title);
          });
        }
        return fetchCartJson('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') }),
        });
      })
      .then(applyCartUpdate);
  }

  function needsVariantPicker(item) {
    if (!item) return false;
    if (item.product_has_only_default_variant === true) return false;
    if (item.product_has_only_default_variant === false) return true;
    return !!(item.variant_title && item.variant_title !== 'Default Title');
  }

  function fetchProductVariants(handle) {
    if (!handle) return Promise.resolve(null);
    if (productVariantsCache[handle]) return Promise.resolve(productVariantsCache[handle]);
    return fetch(apiRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        productVariantsCache[handle] = product;
        cacheVariantComparePrices(product);
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function getVariantPicker(row) {
    return row ? row.querySelector('[data-mm-variant-picker]') : null;
  }

  function dockVariantMenu(picker) {
    if (!picker) return;
    var menu = picker._floatMenu || picker.querySelector('[data-mm-variant-menu]');
    if (!menu) return;
    menu.classList.remove('is-floating', 'is-flip-up');
    menu.hidden = true;
    menu.style.cssText = '';
    if (menu.parentNode !== picker) picker.appendChild(menu);
    delete picker._floatMenu;
  }

  function closeVariantPicker(picker) {
    if (!picker) return;
    picker.classList.remove('is-open');
    dockVariantMenu(picker);
    var trigger = picker.querySelector('[data-mm-variant-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function positionVariantMenuFloat(menu, trigger) {
    if (!menu || !trigger) return;
    var rect = trigger.getBoundingClientRect();
    var gap = 3;
    var maxH = Math.min(180, Math.round(window.innerHeight * 0.32));
    menu.style.position = 'fixed';
    menu.style.left = Math.max(8, rect.left) + 'px';
    menu.style.width = Math.min(rect.width, window.innerWidth - 16) + 'px';
    menu.style.maxHeight = maxH + 'px';
    menu.style.zIndex = '2147483647';
    menu.style.right = 'auto';

    menu.style.visibility = 'hidden';
    menu.style.display = 'block';
    var menuH = menu.scrollHeight || maxH;
    menu.style.visibility = '';

    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    if (spaceBelow < Math.min(menuH, maxH) + 8 && spaceAbove > spaceBelow) {
      menu.classList.add('is-flip-up');
      menu.style.top = 'auto';
      menu.style.bottom = window.innerHeight - rect.top + gap + 'px';
    } else {
      menu.classList.remove('is-flip-up');
      menu.style.bottom = 'auto';
      menu.style.top = rect.bottom + gap + 'px';
    }
  }

  function ensureVariantMenuOptions(picker, callback) {
    var menu = picker.querySelector('[data-mm-variant-menu]');
    if (!menu) {
      callback(false);
      return;
    }
    if (menu.children.length > 0 || picker.getAttribute('data-mm-variants-loaded') === '1') {
      callback(true);
      return;
    }
    var handle = picker.getAttribute('data-product-handle');
    var variantId = parseInt(picker.getAttribute('data-variant-id'), 10);
    fetchProductVariants(handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) {
        callback(false);
        return;
      }
      menu.innerHTML = buildVariantMenuHtml(product.variants, variantId);
      picker.setAttribute('data-mm-variants-loaded', '1');
      callback(true);
    });
  }

  function openVariantPicker(picker) {
    if (!picker) return;
    var menu = picker.querySelector('[data-mm-variant-menu]');
    var trigger = picker.querySelector('[data-mm-variant-toggle]');
    if (!menu || !trigger) return;

    closeAllVariantMenus(picker);

    ensureVariantMenuOptions(picker, function (ok) {
      if (!ok || !menu.children.length || !root) return;
      picker.classList.add('is-open');
      picker._floatMenu = menu;
      root.appendChild(menu);
      menu.classList.add('is-floating');
      menu.hidden = false;
      menu.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        positionVariantMenuFloat(menu, trigger);
      });
    });
  }

  function closeAllVariantMenus(exceptPicker) {
    if (!root) return;
    root.querySelectorAll('[data-mm-variant-picker].is-open').forEach(function (picker) {
      if (exceptPicker && picker === exceptPicker) return;
      closeVariantPicker(picker);
    });
  }

  function setVariantPickerLabel(picker, title) {
    if (!picker) return;
    var label = picker.querySelector('.mm-cart-sheet__variant-trigger-label');
    if (label) label.textContent = title || '';
  }

  function buildVariantMenuHtml(variants, activeId) {
    var html = '';
    variants.forEach(function (v) {
      var active = v.id === activeId ? ' is-active' : '';
      var disabled = v.available ? '' : ' is-disabled';
      var soldBadge = v.available
        ? ''
        : '<span class="mm-cart-sheet__variant-option-badge">' +
          escapeHtml(CFG.soldOut || 'Sold out') +
          '</span>';
      html +=
        '<button type="button" class="mm-cart-sheet__variant-option' +
        active +
        disabled +
        '" data-mm-variant-option="' +
        v.id +
        '" role="option" aria-selected="' +
        (v.id === activeId ? 'true' : 'false') +
        '"' +
        (v.available ? '' : ' disabled') +
        '>' +
        '<span class="mm-cart-sheet__variant-option-check" aria-hidden="true">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">' +
        '<polyline points="20 6 9 17 4 12"/></svg></span>' +
        '<span class="mm-cart-sheet__variant-option-title">' +
        escapeHtml(v.title || '') +
        '</span>' +
        soldBadge +
        '</button>';
    });
    return html;
  }

  function buildVariantPickerHtml(item) {
    if (isCartGiftItem(item)) return '';
    if (!needsVariantPicker(item)) return '';
    var handle = item.handle || '';
    var label = CFG.chooseFlavour || 'Choose flavour';
    var title =
      item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : label;
    return (
      '<div class="mm-cart-sheet__variant-picker" data-mm-variant-picker ' +
      'data-line-key="' +
      escapeHtml(item.key) +
      '" data-quantity="' +
      item.quantity +
      '" data-variant-id="' +
      item.variant_id +
      '" data-product-handle="' +
      escapeHtml(handle) +
      '">' +
      '<button type="button" class="mm-cart-sheet__variant-trigger" data-mm-variant-toggle ' +
      'aria-expanded="false" aria-haspopup="listbox">' +
      '<span class="mm-cart-sheet__variant-trigger-icon" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>' +
      '</svg></span>' +
      '<span class="mm-cart-sheet__variant-trigger-text">' +
      '<span class="mm-cart-sheet__variant-trigger-label">' +
      escapeHtml(title) +
      '</span></span>' +
      '<span class="mm-cart-sheet__variant-trigger-chevron" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
      '<path d="M6 9l6 6 6-6"/></svg></span></button>' +
      '<div class="mm-cart-sheet__variant-menu" data-mm-variant-menu hidden role="listbox"></div>' +
      '</div>'
    );
  }

  function findCartItem(key) {
    if (!cartCache || !cartCache.items) return null;
    for (var i = 0; i < cartCache.items.length; i++) {
      if (cartCache.items[i].key === key) return cartCache.items[i];
    }
    return null;
  }

  function cartLineProperties(item) {
    if (!item || !item.properties) return null;
    var props = {};
    Object.keys(item.properties).forEach(function (k) {
      var val = item.properties[k];
      if (val != null && val !== '') props[k] = val;
    });
    return Object.keys(props).length ? props : null;
  }

  function syncVariantPickerState(picker, item) {
    if (!picker || !item) return;
    picker.setAttribute('data-quantity', item.quantity);
    picker.setAttribute('data-line-key', item.key);
    picker.setAttribute('data-variant-id', item.variant_id);
    setVariantPickerLabel(
      picker,
      item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : CFG.chooseFlavour || 'Choose flavour'
    );
    var menu = picker.querySelector('[data-mm-variant-menu]');
    if (menu) {
      menu.querySelectorAll('[data-mm-variant-option]').forEach(function (btn) {
        var vid = parseInt(btn.getAttribute('data-mm-variant-option'), 10);
        var isActive = vid === item.variant_id;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
  }

  function hydrateVariantPickers(cart) {
    if (!cart || !cart.items || !root) return;
    cart.items.forEach(function (item) {
      if (!needsVariantPicker(item)) return;
      var row = getItemRow(item.key);
      if (!row) return;
      var picker = getVariantPicker(row);
      if (!picker) return;

      syncVariantPickerState(picker, item);

      if (picker.getAttribute('data-mm-variants-loaded') === '1') return;

      var handle = item.handle || picker.getAttribute('data-product-handle');
      var menu = picker.querySelector('[data-mm-variant-menu]');
      if (!menu) return;

      fetchProductVariants(handle).then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        var activeRow = getItemRow(item.key);
        if (!activeRow) return;
        var activePicker = getVariantPicker(activeRow);
        if (!activePicker || activePicker !== picker) return;

        menu.innerHTML = buildVariantMenuHtml(product.variants, item.variant_id);
        picker.setAttribute('data-mm-variants-loaded', '1');
        syncVariantPickerState(picker, item);
        refreshItemPriceRow(item);
      });
    });
  }

  function swapVariantRequest(item, newVariantId, quantity) {
    var qty = quantity || 1;
    var props = cartLineProperties(item);
    if (props) {
      var addPayload = { id: newVariantId, quantity: qty, properties: props };
      return fetchCartJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [addPayload] }),
      }).then(function () {
        return fetchCartJson('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      });
    }

    return fetchCartJson('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    }).then(function () {
      return fetchCartJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: qty }] }),
      });
    });
  }

  function changeVariant(oldKey, newVariantId, quantity, optimisticTitle) {
    if (!oldKey || !newVariantId) return;
    var row = getItemRow(oldKey);
    var picker = row && getVariantPicker(row);
    var item = findCartItem(oldKey);
    if (!item && picker) {
      item = {
        key: oldKey,
        variant_id: parseInt(picker.getAttribute('data-variant-id'), 10),
      };
    }
    if (item && parseInt(item.variant_id, 10) === parseInt(newVariantId, 10)) return;

    pendingKeys[oldKey] = true;
    lastUserLineOpAt = Date.now();
    if (row) row.classList.add('mm-cart-sheet__item--updating');
    if (picker) {
      picker.classList.add('is-busy');
      closeVariantPicker(picker);
      if (optimisticTitle) setVariantPickerLabel(picker, optimisticTitle);
    }

    var doSwap = function () {
      return swapVariantRequest(item, newVariantId, quantity)
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || !isCartPayload(data)) throw data;
            return data;
          });
        });
    };

    var swapPromise = runCartMutation(doSwap);

    swapPromise
      .then(function (cart) {
        if (picker) picker.classList.remove('is-busy');
        applyCartUpdate(cart, { loadRecs: false });
      })
      .catch(function () {
        if (cartCache) {
          applyCartUpdate(cartCache, { loadRecs: false });
          if (picker && item) syncVariantPickerState(picker, item);
        }
      })
      .finally(function () {
        clearItemBusy(oldKey);
        if (picker) picker.classList.remove('is-busy');
      });
  }

  function buildBranchInventoryHtml(item, part) {
    if (!CFG.branchInventoryEnabled) return '';
    var handle = item.handle || '';
    if (part === 'payload') {
      return '<script type="application/json" class="mm-inv-payload" data-mm-inv-loading="1"></script>';
    }
    return (
      '<div class="mm-inv-root mm-inv--cart-item-detail mm-cart-sheet__item-branch"' +
      ' data-variant-id="' +
      item.variant_id +
      '"' +
      ' data-product-handle="' +
      escapeHtml(handle) +
      '"' +
      ' data-mm-inv-pickup-yes="' +
      escapeHtml(CFG.branchPickupYes || '✓') +
      '"' +
      ' data-mm-inv-pickup-no="' +
      escapeHtml(CFG.branchPickupNo || '✗') +
      '"' +
      ' data-mm-inv-available="' +
      escapeHtml(CFG.branchInvAvailable || 'Available') +
      '"' +
      ' data-mm-inv-unavailable="' +
      escapeHtml(CFG.branchInvUnavailable || 'Unavailable') +
      '"' +
      ' aria-live="polite"><div class="mm-inv-mount"></div></div>'
    );
  }

  function refreshCartBranchInventory(cart) {
    if (!CFG.branchInventoryEnabled || !window.MMBranchInventory) return;
    var sheet = document.getElementById('mmCartSheet');
    if (typeof window.MMBranchInventory.hydrateCartItems === 'function') {
      window.MMBranchInventory.hydrateCartItems(cart, sheet || document);
    } else if (typeof window.MMBranchInventory.updateCartNotice === 'function') {
      window.MMBranchInventory.updateCartNotice(sheet || document);
    }
  }

  function refreshCartVariantExpiry(scope) {
    if (window.MMVariantExpiry && typeof window.MMVariantExpiry.resetAndHydrate === 'function') {
      window.MMVariantExpiry.resetAndHydrate(scope || root || document);
    } else if (window.MMVariantExpiry && typeof window.MMVariantExpiry.hydrate === 'function') {
      window.MMVariantExpiry.hydrate(scope || root || document);
    }
  }

  function buildExpiryHtml(item) {
    var vt = item.variant_title || '';
    if (!vt || vt === 'Default Title') vt = '';
    if (!item.handle) return '';
    var variantIdAttr = item.variant_id ? ' data-variant-id="' + item.variant_id + '"' : '';
    return (
      '<div class="mm-variant-expiry" data-mm-variant-expiry' +
      ' data-product-handle="' +
      escapeHtml(item.handle) +
      '"' +
      variantIdAttr +
      ' data-variant-title="' +
      escapeHtml(vt) +
      '"></div>'
    );
  }

  function isCartGiftItem(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._gift === 'true';
  }

  function isCartOfferItem(item) {
    if (!item || isCartGiftItem(item)) return false;
    if (window.MMOffers && typeof window.MMOffers.isOfferCartLine === 'function') {
      return window.MMOffers.isOfferCartLine(item);
    }
    var props = item.properties || {};
    if (props._offerType === 'CART_TIER_GIFT' || props.mm_offer_type === 'CART_TIER_GIFT') return false;
    return !!(props._offerId || props._offerType);
  }

  function itemUnitGrams(item, row) {
    var grams = item && parseFloat(item.grams || item.variant_weight || 0);
    if ((grams == null || isNaN(grams)) && row) grams = parseFloat(row.getAttribute('data-item-grams') || '0');
    return !isNaN(grams) && grams >= 0 ? grams : null;
  }

  function weightQtyLimitFor(item, row) {
    if (!CFG.weightQtyLimitsEnabled) return null;
    var grams = itemUnitGrams(item, row);
    if (grams == null) return null;
    var kg = grams / 1000;
    var ranges = Array.isArray(CFG.weightQtyLimitRanges) ? CFG.weightQtyLimitRanges : [];
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i] || {};
      var fromKg = parseFloat(range.fromKg);
      var toKg = parseFloat(range.toKg);
      var minQty = parseInt(range.minQty, 10);
      var maxQty = parseInt(range.maxQty, 10);
      if (isNaN(fromKg)) fromKg = 0;
      if (isNaN(toKg) || toKg <= 0) continue;
      if (isNaN(minQty) || minQty < 0) minQty = 0;
      if (isNaN(maxQty) || maxQty <= 0) continue;
      if (maxQty < minQty) maxQty = minQty;
      if (kg >= fromKg && kg <= toKg) {
        return { min: minQty, max: maxQty, kg: kg };
      }
    }
    return null;
  }

  function weightQtyMessage(limit, type) {
    if (!limit) return '';
    var template = type === 'max'
      ? (CFG.weightQtyMaxMessage || 'Maximum reached for this product: [max].')
      : (CFG.weightQtyMinMessage || 'Minimum for this product is [min] and maximum is [max].');
    return String(template).replace(/\[min\]/g, limit.min).replace(/\[max\]/g, limit.max);
  }

  function setWeightQtyNotice(row, message) {
    if (!row) return;
    var notice = row.querySelector('[data-mm-weight-qty-notice]');
    if (!notice) return;
    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    } else {
      notice.textContent = '';
      notice.hidden = true;
    }
  }

  function syncWeightQtyLimit(row, item) {
    if (!row || !item) return null;
    var limit = weightQtyLimitFor(item, row);
    var qty = parseInt(item.quantity, 10) || 0;
    var minus = row.querySelector('[data-mm-qty="-1"]');
    var plus = row.querySelector('[data-mm-qty="1"]');
    [minus, plus].forEach(function (btn) {
      if (!btn) return;
      btn.removeAttribute('data-mm-weight-block-message');
      btn.classList.remove('is-weight-limit');
    });
    if (!limit) {
      if (minus) minus.disabled = false;
      if (plus && !isCartGiftItem(item)) plus.disabled = false;
      setWeightQtyNotice(row, '');
      return null;
    }
    if (minus) minus.disabled = false;
    if (plus && !isCartGiftItem(item)) plus.disabled = false;
    if (minus && qty <= limit.min) {
      minus.setAttribute('data-mm-weight-block-message', weightQtyMessage(limit, 'min'));
      minus.classList.add('is-weight-limit');
    }
    if (plus && qty >= limit.max) {
      plus.setAttribute('data-mm-weight-block-message', weightQtyMessage(limit, 'max'));
      plus.classList.add('is-weight-limit');
    }
    if (plus && isCartGiftItem(item)) plus.disabled = true;
    if (qty < limit.min) setWeightQtyNotice(row, weightQtyMessage(limit, 'min'));
    else if (qty >= limit.max) setWeightQtyNotice(row, weightQtyMessage(limit, 'max'));
    else setWeightQtyNotice(row, '');
    return limit;
  }

  function cartHasWeightQtyError(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      var row = getItemRow(item.key);
      var limit = weightQtyLimitFor(item, row);
      var qty = item.quantity || 0;
      return !!(limit && qty > 0 && (qty < limit.min || qty > limit.max));
    });
  }

  function buildQtyHtml(item) {
    var qty = item.quantity || 1;
    var isGift = isCartGiftItem(item);
    var giftCls = isGift ? ' mm-cart-sheet__qty--gift' : '';
    var plusDisabled = isGift ? ' disabled aria-disabled="true"' : '';
    return (
      '<div class="mm-cart-sheet__qty' + giftCls + '">' +
      '<button type="button" data-mm-qty="-1" aria-label="-">−</button>' +
      '<span class="mm-cart-sheet__qty-val">' +
      qty +
      '</span>' +
      '<button type="button" data-mm-qty="1" aria-label="+"' +
      plusDisabled +
      '>+</button>' +
      '</div>'
    );
  }

  function buildItemHtml(item) {
    var img = item.image || '';
    var itemUrl = item.url || '/products/' + (item.handle || '');
    if (itemUrl.indexOf('http') !== 0 && localePrefix()) {
      itemUrl = localePrefix() + itemUrl;
    }

    var pricing = getItemPricing(item);
    var compareAttr =
      pricing.hasSale && pricing.compareAtUnit
        ? ' data-compare-at-unit="' + pricing.compareAtUnit + '"'
        : '';
    var handleAttr = item.handle ? ' data-product-handle="' + escapeHtml(item.handle) + '"' : '';
    var offerAttr = isCartOfferItem(item) ? ' data-offer-line="1"' : '';

    var html =
      '<div class="mm-cart-sheet__item" data-cart-key="' +
      escapeHtml(item.key) +
      '" data-variant-id="' +
      item.variant_id +
      '" data-item-grams="' +
      (item.grams || 0) +
      '"' +
      handleAttr +
      offerAttr +
      compareAttr +
      ' data-variant-price="' +
      (item.final_price || item.price || 0) +
      '">';
    html += buildBranchInventoryHtml(item, 'payload');
    html +=
      '<a href="' +
      escapeHtml(itemUrl) +
      '" class="mm-cart-sheet__item-img-wrap">';
    if (img) {
      html +=
        '<img class="mm-cart-sheet__item-img" src="' +
        escapeHtml(img) +
        '" alt="" width="64" height="64" loading="lazy">';
    }
    html +=
      '</a><div class="mm-cart-sheet__item-info">' +
      '<a href="' +
      escapeHtml(itemUrl) +
      '" class="mm-cart-sheet__item-title">' +
      escapeHtml(item.product_title) +
      '</a>';
    html += buildBranchInventoryHtml(item, 'surface');
    html += buildVariantPickerHtml(item);
    html += buildExpiryHtml(item);
    html +=
      '<div class="mm-cart-sheet__item-row">' +
      buildItemPriceHtml(item, null) +
      '<div class="mm-cart-sheet__item-actions">' +
      buildQtyHtml(item) +
      '<button type="button" class="mm-cart-sheet__remove" data-mm-remove aria-label="' +
      escapeHtml(CFG.removeItem || 'Remove') +
      '">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>' +
      '</svg></button></div></div><p class="mm-cart-sheet__qty-limit" data-mm-weight-qty-notice hidden></p></div></div>';
    return html;
  }

  function syncItemsList(cart) {
    var container = $('#mmCartSheetItems');
    var body = $('#mmCartSheetBody');
    var footer = $('#mmCartSheetFooter');
    var incentives = $('#mmCartSheetIncentives');

    if (!cart.items || !cart.items.length) {
      if (body) {
        body.innerHTML =
          '<div class="mm-cart-sheet__empty" id="mmCartSheetEmpty"><p>' +
          escapeHtml(CFG.emptyText || 'Your cart is empty') +
          '</p></div>';
      }
      if (footer) footer.hidden = true;
      if (incentives) incentives.hidden = true;
      var recs = $('#mmCartSheetRecs');
      if (recs) recs.hidden = true;
      lastRecsKey = '';
      refreshCartBranchInventory(cart);
      refreshCartVariantExpiry(root);
      return;
    }

    if (footer) footer.hidden = false;
    if (incentives) incentives.hidden = false;

    if (!container) {
      if (body) {
        body.innerHTML = '<div class="mm-cart-sheet__items" id="mmCartSheetItems"></div>';
        container = $('#mmCartSheetItems');
      }
    }

    if (!container) return;

    var existingKeys = {};
    container.querySelectorAll('.mm-cart-sheet__item[data-cart-key]').forEach(function (el) {
      existingKeys[el.getAttribute('data-cart-key')] = el;
    });

    var cartKeys = {};
    cart.items.forEach(function (item) {
      cartKeys[item.key] = true;
      var el = existingKeys[item.key];
      if (el) {
        el.setAttribute('data-variant-id', item.variant_id);
        el.setAttribute('data-item-grams', item.grams || 0);
        if (item.handle) el.setAttribute('data-product-handle', item.handle);
        var prices = el.querySelector('.mm-cart-sheet__item-prices');
        var qtyVal = el.querySelector('.mm-cart-sheet__qty-val');
        if (prices) {
          var newPricing = getItemPricing(item, el);
          var hasExistingSale = prices.querySelector(
            '.mm-cart-sheet__price-saved, .mm-cart-sheet__price-compare'
          );
          if (!newPricing.hasSale && hasExistingSale) {
            /* Keep Liquid sale display until product.js enrich fills compare_at */
          } else {
            prices.outerHTML = buildItemPriceHtml(item, el);
            if (newPricing.hasSale && newPricing.compareAtUnit) {
              el.setAttribute('data-compare-at-unit', newPricing.compareAtUnit);
            }
          }
        }
        if (qtyVal) qtyVal.textContent = item.quantity;
        var imgEl = el.querySelector('.mm-cart-sheet__item-img');
        if (imgEl && item.image) imgEl.src = item.image;
        var picker = getVariantPicker(el);
        if (picker) {
          if (String(picker.getAttribute('data-variant-id')) !== String(item.variant_id)) {
            picker.removeAttribute('data-mm-variants-loaded');
          }
          syncVariantPickerState(picker, item);
        }
        var expiryEl = el.querySelector('[data-mm-variant-expiry]');
        if (!expiryEl) {
          var infoEl = el.querySelector('.mm-cart-sheet__item-info');
          var rowEl = el.querySelector('.mm-cart-sheet__item-row');
          if (infoEl) {
            var expiryWrap = document.createElement('div');
            expiryWrap.innerHTML = buildExpiryHtml(item);
            var expiryNode = expiryWrap.firstElementChild;
            if (expiryNode) {
              if (rowEl) infoEl.insertBefore(expiryNode, rowEl);
              else infoEl.appendChild(expiryNode);
            }
          }
        } else {
          var expiryTitle =
            item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          expiryEl.setAttribute('data-variant-title', expiryTitle);
          if (item.variant_id) expiryEl.setAttribute('data-variant-id', item.variant_id);
          if (item.handle) expiryEl.setAttribute('data-product-handle', item.handle);
        }
        el.classList.remove('mm-cart-sheet__item--removing', 'mm-cart-sheet__item--updating');
        if (isCartOfferItem(item)) el.setAttribute('data-offer-line', '1');
        else el.removeAttribute('data-offer-line');
        syncWeightQtyLimit(el, item);
      } else {
        var div = document.createElement('div');
        div.innerHTML = buildItemHtml(item);
        var node = div.firstElementChild;
        node.classList.add('mm-cart-sheet__item--enter');
        syncWeightQtyLimit(node, item);
        container.appendChild(node);
        requestAnimationFrame(function () {
          node.classList.remove('mm-cart-sheet__item--enter');
        });
      }
    });

    Object.keys(existingKeys).forEach(function (key) {
      if (!cartKeys[key]) {
        var el = existingKeys[key];
        el.classList.add('mm-cart-sheet__item--removing');
        setTimeout(function () {
          if (el.parentNode) el.remove();
        }, 320);
      }
    });

    hydrateVariantPickers(cart);
    refreshCartBranchInventory(cart);
    refreshCartVariantExpiry(root);
  }

  function setSheetUpdating(on, message) {
    if (on) sheetUpdatingCount++;
    else sheetUpdatingCount = Math.max(0, sheetUpdatingCount - 1);
    var active = sheetUpdatingCount > 0;
    var el = $('#mmCartSheetUpdating');
    var panel = root && root.querySelector('.mm-cart-sheet__panel');
    var msgEl = $('#mmCartSheetUpdatingMsg');
    if (msgEl && message) msgEl.textContent = message;
    else if (msgEl && !active) msgEl.textContent = CFG.updating || 'Updating cart…';
    if (el) {
      el.hidden = !active;
      el.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    if (panel) panel.classList.toggle('is-updating', active);
    if (root) root.classList.toggle('mm-cart-sheet--busy', active);
  }

  function updateFooterTotals(cart) {
    if (!cart) return;
    var subEl = $('#mmCartSheetSubtotal');
    if (!subEl) return;
    subEl.innerHTML = formatMoney(cart.total_price || 0);
  }

  function maybeLoadRecs(cart, force) {
    if (!featureVisible('recommendationsCountries')) {
      var wrap = $('#mmCartSheetRecs');
      if (wrap) wrap.hidden = true;
      return;
    }
    var productIds = (cart.items || []).map(function (i) {
      return i.product_id;
    });
    var key = productIds.join(',');
    if (!force && key === lastRecsKey) return;
    lastRecsKey = key;

    fetchRecommendations(productIds, 6).then(function (recs) {
      renderRecs(recs, productIds);
    });
  }

  function refreshTierGifts(cart, allowPopup) {
    if (!featureVisible('giftCountries')) {
      hideTierGiftUi();
      return;
    }
    if (!window.MMCartTierGifts || !cart || !cart.items) return;
    if (typeof window.MMCartTierGifts.refresh === 'function') {
      window.MMCartTierGifts.refresh(cart, { uiOnly: true, allowPopup: allowPopup !== false });
      return;
    }
    if (typeof window.MMCartTierGifts.updateUI === 'function') {
      window.MMCartTierGifts.updateUI(cart);
    }
  }

  function applyCartUpdate(cart, opts) {
    opts = opts || {};
    if (!isCartPayload(cart)) return;

    if (cart.items) {
      var liveItems = cart.items.filter(function (it) { return (it.quantity || 0) > 0; });
      if (liveItems.length !== cart.items.length) {
        cart = Object.assign({}, cart, {
          items: liveItems,
          item_count: liveItems.reduce(function (s, it) { return s + (it.quantity || 0); }, 0)
        });
      }
    }

    var token = ++cartUpdateToken;
    cartCache = cart;

    updateBadges(cart.item_count, false);
    updateFooterTotals(cart);
    renderIncentives(cart);
    refreshTierGifts(cart, true);
    renderDiscounts(cart);
    syncItemsList(cart);
    if (window.MMCartOffers && typeof window.MMCartOffers.refresh === 'function') {
      window.MMCartOffers.refresh(cart);
    } else {
      requestAnimationFrame(function () {
        if (window.MMCartOffers && typeof window.MMCartOffers.refresh === 'function') {
          window.MMCartOffers.refresh(cart);
        }
      });
    }
    if (token === cartUpdateToken) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, mmUiOnly: true } }));
    }

    var enrichPromise = enrichCartItemPrices(cart);
    if (opts.loadRecs !== false && cart.items && cart.items.length) {
      enrichPromise.then(function () {
        maybeLoadRecs(cart, opts.forceRecs);
      });
    }
  }

  function fetchRecommendations(productIds, limit) {
    if (window.MMRecommendations && typeof window.MMRecommendations.fetch === 'function') {
      return window.MMRecommendations.fetch(productIds, limit || 6);
    }
    return Promise.resolve([]);
  }

  function renderRecs(products, cartProductIds) {
    var wrap = $('#mmCartSheetRecs');
    var scroll = $('#mmCartSheetRecsScroll');
    if (!wrap || !scroll) return;

    var inCart = {};
    (cartProductIds || []).forEach(function (id) {
      inCart[id] = true;
    });

    var filtered = products.filter(function (p) {
      if (inCart[p.id]) return false;
      if (window.MMRecommendations && typeof window.MMRecommendations.isProductPurchasable === 'function') {
        return window.MMRecommendations.isProductPurchasable(p);
      }
      return p && p.available !== false;
    });

    if (!filtered.length) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var addLabel = CFG.recAdd || '+ Add';
    var html = '';

    filtered.forEach(function (p) {
      var pricing =
        window.MMRecommendations && typeof window.MMRecommendations.getDisplayPricing === 'function'
          ? window.MMRecommendations.getDisplayPricing(p)
          : null;
      var v = pricing ? pricing.variant : p.variants && p.variants[0];
      if (!v) return;
      var img =
        window.MMProductImage && typeof window.MMProductImage.url === 'function'
          ? window.MMProductImage.url(p, 200)
          : '';
      if (!img && p.featured_image) {
        img = p.featured_image;
        if (typeof img === 'object' && img.src) img = img.src;
      }
      var url = productPageUrl(p);
      var priceHtml = '';
      if (pricing && pricing.onSale) {
        priceHtml =
          '<span class="mm-cart-sheet__rec-price-sale">' +
          formatMoney(pricing.price) +
          '</span>' +
          '<span class="mm-cart-sheet__rec-price-compare">' +
          formatMoney(pricing.compareAt) +
          '</span>';
      } else {
        priceHtml =
          '<span class="mm-cart-sheet__rec-price-sale">' +
          formatMoney(pricing ? pricing.price : v.price) +
          '</span>';
      }
      var badgeHtml =
        pricing && pricing.onSale
          ? '<span class="mm-cart-sheet__rec-badge">-' + pricing.discountPct + '%</span>'
          : '';

      html +=
        '<div class="mm-cart-sheet__rec-card">' +
        '<a href="' +
        escapeHtml(url) +
        '" class="mm-cart-sheet__rec-img-wrap">' +
        badgeHtml +
        '<img class="mm-cart-sheet__rec-img" src="' +
        escapeHtml(img) +
        '" alt="' +
        escapeHtml(p.title) +
        '" loading="lazy" width="108" height="108"></a>' +
        '<div class="mm-cart-sheet__rec-body">' +
        '<a href="' +
        escapeHtml(url) +
        '" class="mm-cart-sheet__rec-name">' +
        escapeHtml(p.title) +
        '</a>' +
        '<div class="mm-cart-sheet__rec-price">' +
        priceHtml +
        '</div>' +
        '<button type="button" class="mm-cart-sheet__rec-add" data-variant-id="' +
        v.id +
        '">' +
        escapeHtml(addLabel) +
        '</button>' +
        '</div></div>';
    });

    scroll.innerHTML = html;

    scroll.querySelectorAll('.mm-cart-sheet__rec-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!vid || btn.disabled) return;

        var card = btn.closest('.mm-cart-sheet__rec-card');
        var img = card && card.querySelector('.mm-cart-sheet__rec-img');
        var addedLabel = CFG.recAdded || '✓';

        btn.disabled = true;
        btn.classList.add('is-busy');
        if (card) card.classList.add('is-adding');

        var prevCount = cartCache ? cartCache.item_count : 0;
        updateBadges(prevCount + 1, true);

        add(vid, 1, {
          openSheet: false,
          quickAdd: true,
          sourceElement: btn,
          imageUrl: img ? img.src : null,
        })
          .then(function () {
            btn.classList.remove('is-busy');
            btn.classList.add('is-added');
            btn.textContent = addedLabel;
            if (card) {
              card.classList.remove('is-adding');
              card.classList.add('is-added-flash');
            }
            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove('is-added');
              if (card) card.classList.remove('is-added-flash');
              btn.textContent = addLabel;
            }, 650);
          })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-busy', 'is-added');
            if (card) card.classList.remove('is-adding', 'is-added-flash');
            btn.textContent = addLabel;
            if (cartCache) updateBadges(cartCache.item_count, false);
          });
      });
    });
  }

  function renderCart(cart, opts) {
    opts = opts || {};
    if (opts.full) {
      var body = $('#mmCartSheetBody');
      if (body && cart.items && cart.items.length) {
        var html = '';
        cart.items.forEach(function (item) {
          html += buildItemHtml(item);
        });
        body.innerHTML = '<div class="mm-cart-sheet__items" id="mmCartSheetItems">' + html + '</div>';
      }
    }
    applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
  }

  function flushQtyChange(key, next) {
    var row = getItemRow(key);
    pendingKeys[key] = true;
    lastUserLineOpAt = Date.now();

    if (row) {
      row.classList.add('mm-cart-sheet__item--updating');
      var qtyWrap = row.querySelector('.mm-cart-sheet__qty');
      if (qtyWrap) qtyWrap.classList.add('mm-cart-sheet__qty--busy');
      if (next === 0) row.classList.add('mm-cart-sheet__item--removing');
    }

    qtySafetyTimers[key] = setTimeout(function () {
      clearItemBusy(key);
      forceSheetUpdatingOff();
      fetchCartJson('cart.js')
        .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
        .catch(function () {
          if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
        });
    }, 12000);

    setSheetUpdating(true, CFG.updating || 'Updating cart…');

    function doChange() {
      return fetchCartJson('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next }),
      });
    }

    var changePromise = runCartMutation(doChange);

    return changePromise
      .then(function (cart) {
        applyCartUpdate(cart, { loadRecs: next === 0 });
        if (next === 0) {
          showSheetToast(CFG.itemRemoved);
        }
      })
      .catch(function () {
        forceSheetUpdatingOff();
        return fetchCartJson('cart.js')
          .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
          .catch(function () {
            if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
          });
      })
      .finally(function () {
        clearItemBusy(key);
        setSheetUpdating(false);
      });
  }

  function changeQtyByKey(key, delta, setQty) {
    if (!key) return;

    var row = getItemRow(key);
    var qtyEl = row && row.querySelector('.mm-cart-sheet__qty-val');
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (isNaN(cur)) cur = 1;
    var next = setQty ? Math.max(0, delta) : Math.max(0, cur + delta);
    var lineItem = cartCache && cartCache.items
      ? cartCache.items.find(function (it) { return it.key === key; })
      : null;
    var weightLimit = weightQtyLimitFor(lineItem, row);

    if (weightLimit && next > 0 && next < weightLimit.min) {
      if (next > cur) {
        next = weightLimit.min;
      } else {
        var minMsg = weightQtyMessage(weightLimit, 'min');
        setWeightQtyNotice(row, minMsg);
        showSheetToast(minMsg, 'error');
        return;
      }
    }
    if (weightLimit && next > weightLimit.max && next > cur) {
      var maxMsg = weightQtyMessage(weightLimit, 'max');
      setWeightQtyNotice(row, maxMsg);
      showSheetToast(maxMsg, 'error');
      return;
    }

    if (next === cur) return;

    if (cartCache && cartCache.items) {
      if (
        lineItem &&
        delta > 0 &&
        isCartOfferItem(lineItem) &&
        window.MMOffers
      ) {
        var rowBusy = row || getItemRow(key);
        if (rowBusy) rowBusy.classList.add('mm-cart-sheet__item--updating');
        setSheetUpdating(true, CFG.updating || 'Updating cart…');
        var bumpOffer =
          typeof window.MMOffers.increaseOfferLineQty === 'function'
            ? window.MMOffers.increaseOfferLineQty(lineItem, delta, { apply: false })
            : typeof window.MMOffers.increasePlainVariantQty === 'function'
              ? window.MMOffers.increasePlainVariantQty(lineItem.variant_id, delta, { apply: false })
              : null;
        if (bumpOffer) {
          bumpOffer
            .then(function (cart) {
              applyCartUpdate(cart, { loadRecs: false });
            })
            .catch(function () {
              forceSheetUpdatingOff();
              fetchCartJson('cart.js')
                .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
                .catch(function () {
                  if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
                });
            })
            .finally(function () {
              clearItemBusy(key);
              setSheetUpdating(false);
            });
          return;
        }
      }
      if (
        lineItem &&
        isCartGiftItem(lineItem) &&
        next > cur &&
        window.MMCartTotals &&
        typeof window.MMCartTotals.canIncreaseGiftQty === 'function' &&
        !window.MMCartTotals.canIncreaseGiftQty(lineItem, next)
      ) {
        showSheetToast(
          CFG.giftQtyBlocked ||
            ((document.documentElement.lang || '').indexOf('ar') === 0
              ? 'الهدية مجانية — كمية واحدة فقط'
              : 'Free gift — quantity is limited to 1')
        );
        return;
      }
    }

    if (cartCache && cartCache.items) {
      var estCount = 0;
      var nextItems = [];
      cartCache.items.forEach(function (it) {
        var q = it.key === key ? next : it.quantity;
        if (q > 0) {
          estCount += q;
          if (it.key === key) {
            var oldQ = it.quantity || 1;
            var line = it.final_line_price != null ? it.final_line_price : (it.price || 0) * oldQ;
            var unit = oldQ > 0 ? line / oldQ : (it.price || 0);
            nextItems.push(Object.assign({}, it, { quantity: q, final_line_price: Math.round(unit * q) }));
          } else {
            nextItems.push(it);
          }
        }
      });
      var estTotal = nextItems.reduce(function (s, it) {
        if (isCartGiftItem(it)) return s;
        return s + (it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1));
      }, 0);
      cartCache = Object.assign({}, cartCache, { items: nextItems, item_count: estCount, total_price: estTotal });
      updateBadges(estCount, next > cur);
      updateFooterTotals(cartCache);
      renderIncentives(cartCache);
      refreshTierGifts(cartCache, true);
    } else {
      var badgeEl = document.querySelector('.mm-cart-badge, [data-cart-count]');
      var badgeN = badgeEl ? parseInt(badgeEl.textContent, 10) : 0;
      if (!isNaN(badgeN)) updateBadges(Math.max(0, badgeN + (next - cur)), next > cur);
    }

    if (qtyEl) {
      qtyEl.textContent = next;
      if (lineItem && row) syncWeightQtyLimit(row, Object.assign({}, lineItem, { quantity: next }));
      if (row) {
        row.classList.add('mm-cart-sheet__item--pulse');
        setTimeout(function () {
          if (row) row.classList.remove('mm-cart-sheet__item--pulse');
        }, 280);
      }
    }

    function scheduleFlush() {
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        if (pendingKeys[key]) {
          scheduleFlush();
          return;
        }
        flushQtyChange(key, next);
      }, 280);
    }
    scheduleFlush();
  }

  function showSheetToast(msg, type) {
    if (!msg) return;
    var banner = $('#mmCartSheetSuccess');
    var text = $('#mmCartSheetSuccessText');
    if (!banner || !text) return;
    text.textContent = msg;
    banner.classList.toggle('mm-cart-sheet__success--error', type === 'error');
    banner.classList.add('is-visible');
    clearTimeout(banner._hideTimer);
    banner._hideTimer = setTimeout(function () {
      banner.classList.remove('is-visible');
      banner.classList.remove('mm-cart-sheet__success--error');
    }, 2200);
  }

  function bindCartActions() {
    if (!root || actionsBound) return;
    actionsBound = true;

    root.addEventListener(
      'click',
      function (e) {
        var checkoutBtn = e.target.closest('.mm-cart-sheet__btn--checkout');
        if (checkoutBtn && cartHasWeightQtyError(cartCache)) {
          e.preventDefault();
          showSheetToast(CFG.weightQtyCheckoutMessage || 'Some products need quantity changes before checkout.', 'error');
          return;
        }

        var qtyBtn = e.target.closest('[data-mm-qty]');
        if (qtyBtn) {
          e.preventDefault();
          e.stopPropagation();
          var blockMsg = qtyBtn.getAttribute('data-mm-weight-block-message');
          if (blockMsg) {
            var blockRow = qtyBtn.closest('.mm-cart-sheet__item');
            setWeightQtyNotice(blockRow, blockMsg);
            showSheetToast(blockMsg, 'error');
            return;
          }
          if (qtyBtn.disabled || qtyBtn.getAttribute('aria-disabled') === 'true') return;
          var row = qtyBtn.closest('.mm-cart-sheet__item');
          var key = row && row.getAttribute('data-cart-key');
          var delta = parseInt(qtyBtn.getAttribute('data-mm-qty'), 10);
          if (key && !isNaN(delta)) changeQtyByKey(key, delta);
          return;
        }

        var removeBtn = e.target.closest('[data-mm-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          var removeRow = removeBtn.closest('.mm-cart-sheet__item');
          var rKey = removeRow && removeRow.getAttribute('data-cart-key');
          if (rKey) {
            clearTimeout(qtyTimers[rKey]);
            flushQtyChange(rKey, 0);
          }
          return;
        }

        if (e.target.closest('[data-mm-apply-discount]')) {
          e.preventDefault();
          applyDiscount();
          return;
        }

        var rmDisc = e.target.closest('[data-mm-remove-discount]');
        if (rmDisc) {
          e.preventDefault();
          removeDiscount(rmDisc.getAttribute('data-mm-remove-discount'));
        }

        var variantToggle = e.target.closest('[data-mm-variant-toggle]');
        if (variantToggle) {
          e.preventDefault();
          e.stopPropagation();
          var pickerEl = variantToggle.closest('[data-mm-variant-picker]');
          if (!pickerEl || pickerEl.classList.contains('is-busy')) return;
          if (pickerEl.classList.contains('is-open')) {
            closeVariantPicker(pickerEl);
          } else {
            openVariantPicker(pickerEl);
          }
          return;
        }

        var variantOpt = e.target.closest('[data-mm-variant-option]');
        if (variantOpt && !variantOpt.disabled) {
          e.preventDefault();
          e.stopPropagation();
          var pickerWrap =
            variantOpt.closest('[data-mm-variant-picker]') ||
            (function () {
              var floatMenu = variantOpt.closest('[data-mm-variant-menu].is-floating');
              if (!floatMenu || !root) return null;
              var openPickers = root.querySelectorAll('[data-mm-variant-picker].is-open');
              for (var i = 0; i < openPickers.length; i++) {
                if (openPickers[i]._floatMenu === floatMenu) return openPickers[i];
              }
              return null;
            })();
          if (!pickerWrap || pickerWrap.classList.contains('is-busy')) return;
          closeVariantPicker(pickerWrap);
          var lineKey = pickerWrap.getAttribute('data-line-key');
          var newVariant = parseInt(variantOpt.getAttribute('data-mm-variant-option'), 10);
          var oldVariant = parseInt(pickerWrap.getAttribute('data-variant-id'), 10);
          var lineQty = parseInt(pickerWrap.getAttribute('data-quantity'), 10) || 1;
          var optTitleEl = variantOpt.querySelector('.mm-cart-sheet__variant-option-title');
          var optTitle = optTitleEl ? optTitleEl.textContent.trim() : '';
          if (lineKey && newVariant && newVariant !== oldVariant) {
            changeVariant(lineKey, newVariant, lineQty, optTitle);
          }
          return;
        }

        if (
          !e.target.closest('[data-mm-variant-picker]') &&
          !e.target.closest('[data-mm-variant-menu].is-floating')
        ) {
          closeAllVariantMenus();
        }
      },
      { passive: false }
    );

    var scrollEl = $('#mmCartSheetScroll');
    if (scrollEl && !scrollEl._mmVariantScrollBound) {
      scrollEl._mmVariantScrollBound = true;
      scrollEl.addEventListener(
        'scroll',
        function () {
          closeAllVariantMenus();
        },
        { passive: true }
      );
    }

    var discInput = $('#mmCartSheetDiscountInput');
    if (discInput) {
      discInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscount();
        }
      });
    }
  }

  function showSuccessBanner(title) {
    var banner = $('#mmCartSheetSuccess');
    var text = $('#mmCartSheetSuccessText');
    if (!banner) return;
    if (text) {
      text.textContent = (CFG.addedText || 'Added to cart') + (title ? ': ' + title : '');
    }
    banner.classList.add('is-visible');
    clearTimeout(banner._hideTimer);
    banner._hideTimer = setTimeout(function () {
      banner.classList.remove('is-visible');
    }, 3200);
  }

  function setOverlayState(opening) {
    document.body.classList.toggle('mm-cart-sheet-open', opening);
  }

  function open(opts) {
    opts = opts || {};
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setOverlayState(true);
    isOpen = true;
    updateSdd();
    if (opts.cart && isCartPayload(opts.cart)) {
      applyCartUpdate(opts.cart, { forceRecs: true, loadRecs: true });
    } else if (!opts.skipRefresh) {
      refresh();
    } else {
      refreshCartVariantExpiry(root);
    }
  }

  function close() {
    if (!root) return;
    closeAllVariantMenus();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setOverlayState(false);
    isOpen = false;
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      applyCartUpdate(cart, { forceRecs: !lastRecsKey });
      return cart;
    });
  }

  function addToCartRequest(variantId, quantity, options) {
    options = options || {};
    var qty = quantity || 1;
    var openSheet = options.openSheet !== false;
    var quickAdd = options.quickAdd === true;
    var sourceEl = options.sourceElement;
    var imageUrl = options.imageUrl;

    skipGlobalHook = true;
    var payload = { id: variantId, quantity: qty };
    if (window.MMBogo && typeof window.MMBogo.buildItems === 'function') {
      var bogoItems = window.MMBogo.buildItems(variantId, qty);
      if (bogoItems.length > 1) {
        payload = { items: bogoItems };
      }
    }
    return fetchCartJson('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (item) {
        lastAddedTitle = item.product_title || item.title || '';
        if (imageUrl || item.image) flyToCart(sourceEl, imageUrl || item.image);
        return fetchCart();
      })
      .then(function (cart) {
        updateBadges(cart.item_count, !quickAdd);
        if (!quickAdd) lastRecsKey = '';
        var updateOpts = { forceRecs: !quickAdd, loadRecs: !quickAdd };
        applyCartUpdate(cart, updateOpts);
        if (openSheet) {
          showSuccessBanner(lastAddedTitle);
          if (!isOpen) open({ skipRefresh: true, cart: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .finally(function () {
        skipGlobalHook = false;
      });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('timeout'));
      }, ms);
      promise.then(
        function (value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function setAtcBusy(el, on) {
    if (!el || !el.classList) return;
    if (on) {
      el.classList.add('mm-atc-busy');
      el.setAttribute('aria-busy', 'true');
      try {
        if (window.getComputedStyle(el).position === 'static') {
          el.style.position = 'relative';
          el.setAttribute('data-mm-atc-pos', '1');
        }
      } catch (e) {}
    } else {
      el.classList.remove('mm-atc-busy');
      el.setAttribute('aria-busy', 'false');
      if (el.getAttribute('data-mm-atc-pos') === '1') {
        el.style.position = '';
        el.removeAttribute('data-mm-atc-pos');
      }
    }
  }

  function add(variantId, quantity, options) {
    options = options || {};
    var sourceEl = options.sourceElement || null;
    if (sourceEl && sourceEl._mmAtcJob) return sourceEl._mmAtcJob;

    setAtcBusy(sourceEl, true);

    var job = pendingAddChain.then(function () {
      return withTimeout(addToCartRequest(variantId, quantity, options), 12000);
    });
    pendingAddChain = job.catch(function () {});
    if (sourceEl) sourceEl._mmAtcJob = job;
    return job.finally(function () {
      setAtcBusy(sourceEl, false);
      if (sourceEl) sourceEl._mmAtcJob = null;
    });
  }

  var ATC_FAST_SEL = [
    '.mmupi-atc',
    '.mmupi-sticky-atc',
    '.mmupi-bar-atc',
    '.mmupi-fbt-add',
    '.mmupi-bogo-banner__btn',
    '.mmshop-add-btn',
    '.mms-add-btn',
    '.mm-col-add-btn',
    '.mmpi-atc',
    '.mmpim-atc',
    '.mmo-atc',
    '.mm-feed-atc',
    '.mm-pop-atc-btn',
    '.mm-op-atc-btn',
    '.mm-smart-add-btn',
    '.mm-ymal-card__add',
    '.mm-cart-sheet__rec-add',
    '.mmh-carousel-card__add',
    '.mmh-product__add',
    '.mmh-offer__add',
    '[data-mmh-add]',
    'button[name="add"]',
    '.quick-add__button'
  ].join(',');

  function hookFastAtcButtons() {
    if (window.__mmAtcFastBound) return;
    window.__mmAtcFastBound = true;

    document.addEventListener(
      'pointerdown',
      function (e) {
        if (e.button != null && e.button !== 0) return;
        var btn = e.target && e.target.closest ? e.target.closest(ATC_FAST_SEL) : null;
        if (!btn || btn.disabled || btn.classList.contains('mm-atc-busy')) return;
        btn.classList.add('mm-atc-press');
      },
      true
    );

    function clearPress(e) {
      var btn = e.target && e.target.closest ? e.target.closest(ATC_FAST_SEL) : null;
      if (btn) btn.classList.remove('mm-atc-press');
    }

    document.addEventListener('pointerup', clearPress, true);
    document.addEventListener('pointercancel', clearPress, true);
  }

  function hookGlobalAddToCart() {
    if (window.__mmCartHooked) return;
    window.__mmCartHooked = true;

    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

      return origFetch.apply(this, arguments).then(function (res) {
        if (!isAdd || !res.ok || skipGlobalHook || window.__mmTierGiftCartOps || !root) return res;

        res
          .clone()
          .json()
          .then(function (data) {
            return fetchCart().then(function (cart) {
              updateBadges(cart.item_count, true);
              lastRecsKey = '';
              applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              showSuccessBanner(data.product_title || data.title || '');
              if (!isOpen) open({ skipRefresh: true, cart: cart });
            });
          })
          .catch(function () {});

        return res;
      });
    };

    var XHR = window.XMLHttpRequest;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this._mmCartUrl = url || '';
      this._mmCartMethod = (method || '').toUpperCase();
      return origOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      var xhr = this;
      var url = xhr._mmCartUrl || '';
      var isAdd = xhr._mmCartMethod === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (isAdd) {
        xhr.addEventListener('load', function () {
          if (skipGlobalHook || window.__mmTierGiftCartOps || !root || xhr.status < 200 || xhr.status >= 300) return;
          fetchCart().then(function (cart) {
            updateBadges(cart.item_count, true);
            lastRecsKey = '';
            applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            showSuccessBanner('');
            if (!isOpen) open({ skipRefresh: true, cart: cart });
          });
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function bindTriggers() {
    document.querySelectorAll('[data-mm-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    document.querySelectorAll('[data-mm-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var continueBtn = $('#mmCartSheetContinue');
    if (continueBtn) {
      continueBtn.addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }

  function initSmartRecsContainers() {
    document.querySelectorAll('[data-mm-smart-recs]').forEach(function (container) {
      if (container.dataset.mmRecsLoaded) return;
      container.dataset.mmRecsLoaded = '1';

      var productId = container.getAttribute('data-product-id');
      var limit = parseInt(container.getAttribute('data-limit'), 10) || 4;
      var excludeId = parseInt(container.getAttribute('data-exclude-id'), 10);

      function renderFbt(products) {
        var filtered = products.filter(function (p) {
          return p.id !== excludeId;
        });
        if (!filtered.length) {
          container.innerHTML = '';
          container.closest('.mmupi-fbt')?.remove();
          return;
        }

        var addLabel = CFG.recAdd || '+ Add';
        var html = '';
        filtered.slice(0, limit).forEach(function (p) {
          var v =
            (p.variants && p.variants.find(function (x) {
              return x.available;
            })) ||
            p.variants[0];
          if (!v) return;
          var img = p.featured_image;
          if (typeof img === 'string') {
            /* ok */
          } else if (img && img.src) {
            img = img.src;
          } else {
            img = '';
          }
          var price = v.price;
          html +=
            '<div class="mmupi-fbt-item" data-fbt-source="shopify-api">' +
            '<div class="mmupi-fbt-img"><a href="' +
            escapeHtml(productPageUrl(p)) +
            '"><img src="' +
            escapeHtml(img) +
            '" alt="' +
            escapeHtml(p.title) +
            '" loading="lazy" width="100" height="100"></a></div>' +
            '<div class="mmupi-fbt-info"><p class="mmupi-fbt-name">' +
            escapeHtml(p.title.length > 35 ? p.title.slice(0, 35) + '…' : p.title) +
            '</p><span class="mmupi-fbt-price">' +
            formatMoney(price) +
            '</span></div>' +
            '<button type="button" class="mmupi-fbt-add" data-variant-id="' +
            v.id +
            '">' +
            escapeHtml(addLabel) +
            '</button></div>';
        });
        container.innerHTML = html;

        container.querySelectorAll('.mmupi-fbt-add').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
            if (!vid) return;
            var orig = btn.textContent;
            btn.disabled = true;
            btn.classList.add('mm-atc-busy');
            add(vid, 1, { sourceElement: btn }).finally(function () {
              btn.classList.remove('mm-atc-busy');
              btn.textContent = '✓';
              btn.style.background = '#10B981';
              setTimeout(function () {
                btn.textContent = orig;
                btn.style.background = '';
                btn.disabled = false;
              }, 1400);
            });
          });
        });
      }

      fetchRecommendations([productId], limit + 2).then(renderFbt);
    });
  }

  function init() {
    root = document.getElementById('mm-cart-sheet');
    if (!root) {
      console.warn('[MMCart] #mm-cart-sheet not found — is theme.liquid rendering mm-cart-sheet snippet?');
      return;
    }
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
    hookGlobalAddToCart();
    hookFastAtcButtons();
    bindTriggers();
    bindCartActions();
    initSmartRecsContainers();

    updateSdd();
    if (sddTimer) clearInterval(sddTimer);
    sddTimer = setInterval(updateSdd, 1000);

    fetchCart().then(function (cart) {
      cartCache = cart;
      if (cart.items && cart.items.length) {
        updateFooterTotals(cart);
        renderIncentives(cart);
        renderDiscounts(cart);
        maybeLoadRecs(cart, true);
      }
      try {
        if (sessionStorage.getItem('mm_open_cart') === '1') {
          sessionStorage.removeItem('mm_open_cart');
          setTimeout(function () { open({ skipRefresh: true, cart: cart }); }, 120);
        }
      } catch (e) {}
    });

    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('mm:currency-change', function () {
      updateSdd();
      if (cartCache) {
        renderIncentives(cartCache);
        renderDiscounts(cartCache);
      }
    });
  }

  function forceSheetUpdatingOff() {
    sheetUpdatingCount = 0;
    var el = $('#mmCartSheetUpdating');
    var panel = root && root.querySelector('.mm-cart-sheet__panel');
    var msgEl = $('#mmCartSheetUpdatingMsg');
    if (msgEl) msgEl.textContent = CFG.updating || 'Updating cart…';
    if (el) {
      el.hidden = true;
      el.setAttribute('aria-busy', 'false');
    }
    if (panel) panel.classList.remove('is-updating');
    if (root) root.classList.remove('mm-cart-sheet--busy');
  }

  function runWithoutHook(fn) {
    skipGlobalHook = true;
    return Promise.resolve().then(fn).finally(function () {
      skipGlobalHook = false;
    });
  }

  function runCartMutation(fn) {
    var job = cartMutChain.then(function () {
      return cartPause(50).then(function () {
        return runWithoutHook(fn);
      });
    });
    cartMutChain = job.catch(function () {});
    return job;
  }

  function waitForCartIdle(maxMs) {
    maxMs = maxMs || 4000;
    var start = Date.now();
    return new Promise(function (resolve) {
      function tick() {
        if (!hasPendingLineOps()) {
          resolve();
          return;
        }
        if (Date.now() - start >= maxMs) {
          resolve();
          return;
        }
        setTimeout(tick, 60);
      }
      tick();
    });
  }

  function hasPendingLineOps() {
    return Object.keys(pendingKeys).length > 0;
  }

  window.MMCart = {
    add: add,
    setButtonBusy: setAtcBusy,
    open: open,
    close: close,
    refresh: refresh,
    updateBadges: updateBadges,
    cartApi: cartApi,
    runWithoutHook: runWithoutHook,
    runCartMutation: runCartMutation,
    waitForCartIdle: waitForCartIdle,
    applyUpdate: applyCartUpdate,
    getCart: function () { return cartCache; },
    fetchCart: fetchCart,
    hasPendingLineOps: hasPendingLineOps,
    getLastLineOpAt: function () { return lastUserLineOpAt; },
    setSheetUpdating: setSheetUpdating,
    clearSheetUpdating: forceSheetUpdatingOff,
    showToast: showSheetToast
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
